export const COLUMNS_TRANSACTION = [
    {
        Header: 'ID',
        accessor: 'block_number'
    },
    // {
    //     Header: 'Hash',
    //     accessor: 'hash'
    // },
    {
        Header: 'From',
        accessor: 'from_address'
    },
    {
        Header: 'To',
        accessor: 'to_address'
    },
    // {
    //     Header: 'Gas Price',
    //     accessor: 'gas_price'
    // },
    // {
    //     Header: 'Gas',
    //     accessor: 'gas'
    // },
    {
        Header: 'Timestamp',
        accessor: 'block_timestamp'
    },
]